import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    locale: { type: String, default: "pl" },
    fieldName: String,
  }

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      hiddenInput: () => ({ phone: `${this.fieldNameValue}[full_phone_number]` }),
      initialCountry: 'pl',
      countryNameLocale: this.localeValue,
      dropdownContainer: document.body,
      dropdownParent: document.body,
      // eslint-disable-next-line import/no-unresolved
      loadUtils: () => import('intl-tel-input/utils'),
    })
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy()
      this.iti = null
    }
  }
}
